import { Close } from '@mui/icons-material';
import { Alert, AlertTitle, IconButton, Typography } from '@mui/material';
import { ENotificationType, type INotification } from '@sharedInterfaces/INotification';
import ExpandableText from '@src/App/Components/General/ExpandableText/ExpandableText';
import React from 'react';

interface NotificationItemProps {
    notification: INotification;
    onDelete: (id: string | number) => void;
}

const NotificationItem: React.FC<NotificationItemProps> = ({ notification, onDelete }) => {
    //use enum if fits else ...
    const serverity =
        notification.notificationType === ENotificationType.ERROR
            ? 'error'
            : notification.notificationType === ENotificationType.WARNING
              ? 'warning'
              : notification.notificationType === ENotificationType.SUCCESS
                ? 'success'
                : 'info';
    return (
        <Alert
            severity={serverity}
            style={{ marginBottom: '10px' }}
            action={
                <IconButton size="small" onClick={() => onDelete(notification.id)}>
                    <Close />
                </IconButton>
            }
        >
            <AlertTitle>{notification.title}</AlertTitle>
            <ExpandableText initialHeight={140}>
                <div dangerouslySetInnerHTML={{ __html: notification.messageHTML }} />
            </ExpandableText>
            <Typography
                component="span"
                variant="caption"
                textAlign={'right'}
                color="textSecondary"
                style={{ display: 'block', marginTop: '0.5rem' }}
            >
                {new Date(notification.publishedAt).toLocaleString()}
            </Typography>
        </Alert>
    );
};

export default NotificationItem;
